"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var hat_1 = __importDefault(require("hat"));
var common_1 = require("stremio/common");
var STREMIO_URL = 'https://www.strem.io';
var MAX_TRIES = 25;
var getCredentials = function (state) { return __awaiter(void 0, void 0, void 0, function () {
    var response, user, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch("".concat(STREMIO_URL, "/login-fb-get-acc/").concat(state))];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                user = (_a.sent()).user;
                return [2 /*return*/, Promise.resolve({
                        email: user.email,
                        password: user.fbLoginToken,
                    })];
            case 3:
                e_1 = _a.sent();
                console.error('Failed to get credentials from facebook auth', e_1);
                return [2 /*return*/, Promise.reject(e_1)];
            case 4: return [2 /*return*/];
        }
    });
}); };
var useFacebookLogin = function () {
    var platform = (0, common_1.usePlatform)();
    var started = (0, react_1.useRef)(false);
    var timeout = (0, react_1.useRef)(null);
    var start = (0, react_1.useCallback)(function () { return new Promise(function (resolve, reject) {
        started.current = true;
        var state = (0, hat_1.default)(128);
        var tries = 0;
        platform.openExternal("".concat(STREMIO_URL, "/login-fb/").concat(state));
        var waitForCredentials = function () {
            if (started.current) {
                timeout.current && clearTimeout(timeout.current);
                timeout.current = setTimeout(function () {
                    if (tries >= MAX_TRIES)
                        return reject(new Error('Failed to authenticate with facebook'));
                    tries++;
                    getCredentials(state)
                        .then(resolve)
                        .catch(waitForCredentials);
                }, 1000);
            }
        };
        waitForCredentials();
    }); }, []);
    var stop = (0, react_1.useCallback)(function () {
        started.current = false;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    (0, react_1.useEffect)(function () {
        return function () { return stop(); };
    }, []);
    return [
        start,
        stop,
    ];
};
module.exports = useFacebookLogin;
